/**
 * A random RFC 4122 version-4 UUID.
 *
 * Browsers only expose `crypto.randomUUID()` in a secure context — https, or
 * localhost. A console opened over plain http on an IP address (a demo server,
 * a LAN install before TLS) has no such function, and every call site that
 * relied on it failed: sign-in, sending a code, every form that carries an
 * Idempotency-Key. `crypto.getRandomValues()` exists in every context, so the
 * fallback builds the same shape from it.
 */
export function randomUuid() {
    const c = globalThis.crypto;
    if (typeof c?.randomUUID === 'function')
        return c.randomUUID();
    const bytes = new Uint8Array(16);
    c.getRandomValues(bytes);
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40; // version 4
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80; // RFC 4122 variant
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
//# sourceMappingURL=ids.js.map